import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var justify_left_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M9 9v6h11V9H9zM4 20h1.5V4H4v16z" }) });
export {
  justify_left_default as default
};
//# sourceMappingURL=justify-left.js.map
